import { getScoreLetterFromScore } from '@/domain/impact-calculate/utils/get-score-letter-from-score';
import {
  CalculateTourEnv,
  EMPTY_CALCULATE_TOUR_ENV,
} from '@/domain/impact-calculate-tour/entities/calculate-tour-env.entity';

import { ResultsTourDto } from '../dto.type';

export function mapEnv(dto: ResultsTourDto): CalculateTourEnv {
  return dto.general.env
    ? {
        general: {
          scoreLetter: getScoreLetterFromScore(
            dto.general.env.score / dto.general.env.maxScore,
          ),
          score: dto.general.env.score,
          maxScore: dto.general.env.maxScore,
          topics: {
            COMMUNICATION: {
              score: dto.general.env.topics.COMMUNICATION.score,
              maxScore: dto.general.env.topics.COMMUNICATION.maxScore,
              sections: {
                DIGITAL_COMMUNICATION: {
                  score:
                    dto.general.env.topics.COMMUNICATION.sections
                      .DIGITAL_COMMUNICATION.score,
                  maxScore:
                    dto.general.env.topics.COMMUNICATION.sections
                      .DIGITAL_COMMUNICATION.maxScore,
                },
                PHYSICAL_COMMUNICATION: {
                  score:
                    dto.general.env.topics.COMMUNICATION.sections
                      .PHYSICAL_COMMUNICATION.score,
                  maxScore:
                    dto.general.env.topics.COMMUNICATION.sections
                      .PHYSICAL_COMMUNICATION.maxScore,
                },
              },
            },
            FOOD_BEVERAGES: {
              score: dto.general.env.topics.FOOD_BEVERAGES.score,
              maxScore: dto.general.env.topics.FOOD_BEVERAGES.maxScore,
              sections: {
                CATERING: {
                  score:
                    dto.general.env.topics.FOOD_BEVERAGES.sections.CATERING
                      .score,
                  maxScore:
                    dto.general.env.topics.FOOD_BEVERAGES.sections.CATERING
                      .maxScore,
                },
                DISHES: {
                  score:
                    dto.general.env.topics.FOOD_BEVERAGES.sections.DISHES.score,
                  maxScore:
                    dto.general.env.topics.FOOD_BEVERAGES.sections.DISHES
                      .maxScore,
                },
              },
            },
            PUBLIC_ENGAGEMENT: {
              score: dto.general.env.topics.PUBLIC_ENGAGEMENT.score,
              maxScore: dto.general.env.topics.PUBLIC_ENGAGEMENT.maxScore,
              sections: {
                PUBLIC_INFORMATION: {
                  score:
                    dto.general.env.topics.PUBLIC_ENGAGEMENT.sections
                      .PUBLIC_INFORMATION.score,
                  maxScore:
                    dto.general.env.topics.PUBLIC_ENGAGEMENT.sections
                      .PUBLIC_INFORMATION.maxScore,
                },
                PARTNERSHIP_STRATEGY: {
                  score:
                    dto.general.env.topics.PUBLIC_ENGAGEMENT.sections
                      .PARTNERSHIP_STRATEGY.score,
                  maxScore:
                    dto.general.env.topics.PUBLIC_ENGAGEMENT.sections
                      .PARTNERSHIP_STRATEGY.maxScore,
                },
              },
            },
            RESOURCES_POLLUTION: {
              score: dto.general.env.topics.RESOURCES_POLLUTION.score,
              maxScore: dto.general.env.topics.RESOURCES_POLLUTION.maxScore,
              sections: {
                WATER_AND_WASTE: {
                  score:
                    dto.general.env.topics.RESOURCES_POLLUTION.sections
                      .WATER_AND_WASTE.score,
                  maxScore:
                    dto.general.env.topics.RESOURCES_POLLUTION.sections
                      .WATER_AND_WASTE.maxScore,
                },
              },
            },
            EQUIPMENT_AND_SCENOGRAPHY: {
              score: dto.general.env.topics.EQUIPMENT_AND_SCENOGRAPHY.score,
              maxScore:
                dto.general.env.topics.EQUIPMENT_AND_SCENOGRAPHY.maxScore,
              sections: {
                SCENOGRAPHY: {
                  score:
                    dto.general.env.topics.EQUIPMENT_AND_SCENOGRAPHY.sections
                      .SCENOGRAPHY.score,
                  maxScore:
                    dto.general.env.topics.EQUIPMENT_AND_SCENOGRAPHY.sections
                      .SCENOGRAPHY.maxScore,
                },
                TECHNIQUE: {
                  score:
                    dto.general.env.topics.EQUIPMENT_AND_SCENOGRAPHY.sections
                      .TECHNIQUE.score,
                  maxScore:
                    dto.general.env.topics.EQUIPMENT_AND_SCENOGRAPHY.sections
                      .TECHNIQUE.maxScore,
                },
              },
            },
          },
        },
      }
    : EMPTY_CALCULATE_TOUR_ENV;
}
